import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect, useMemo, useState } from "preact/hooks";

import FlickityCarousel from "./elements/FlickityCarousel"

import { getSrcset, flktyVisualsInitCheck } from "../helpers"
import { filterImages, visualFilterFlktyOptions } from "../config"

export default function VisualFacet({ facet }) {
    const { toggleProductFilter } = useFacet(facet);
    const images = useMemo(() => filterImages?.[facet.name], []);
    const [ sortedValues, setSortedValues ] = useState([]);
    const order = useMemo(() => Object.keys(filterImages?.[facet.name]), []);

    useEffect(() => {
        const sorted = [...facet.data].sort((a, b) => {
            return order.indexOf(a.value) - order.indexOf(b.value)
        })
        setSortedValues(sorted);
    }, [ facet.data ])

    return (
        <div className="ns-visual-filters__wrapper">
            <FlickityCarousel 
                className="ns-visual-filters__list ns-visual-filters__carousel"
                checkInit={() => flktyVisualsInitCheck(sortedValues.length ?? 0)}
                options={visualFilterFlktyOptions}
            >
                {sortedValues.map(value => {
                    const filterImage = images[value.value];
                    return ((filterImage && filterImage !== "") &&
                        <div
                            class={`ns-visual-filters__item ns-relative ${value.selected ? "ns-checked" : ""}`}
                            data-nosto-element="facet-setting"
                            key={value.value}
                        >
                            <label className="ns-visual-filters__label ns-flex ns-flex-col ns-w-full ns-h-full">
                                <div className="ns-visual-filters__img-wrap ns-relative ns-w-full">
                                    <img 
                                        className="ns-visual-filters__img ns-block ns-w-full ns-h-full"
                                        src={filterImage.replace('.jpg', '_250x.jpg').replace('.png', '_250x.png').replace('.webp', '_250x.webp')}
                                        alt={`Image for filter ${value.value}`}
                                        width="100"
                                        height="125"
                                        loading="lazy"
                                    />
                                </div>
                                <span className="ns-visual-filters__text ns-flex ns-justify-center">
                                    {value.value}
                                </span>
                                <input
                                    className="ns-visual-filters__input"
                                    type="checkbox" 
                                    checked={value.selected} 
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }} 
                                />
                            </label>
                        </div>
                    )
                })}
            </FlickityCarousel>
        </div>
    )
}